import { HttpClient } from '@angular/common/http';
import { EventEmitter, Injectable } from '@angular/core';
import { HubConnectionBuilder, HubConnectionState } from '@aspnet/signalr';
import { environment } from '../../environments/environment';
import { Message } from '../models/Message';
import { AuthService } from './auth.service';
import { MyLogger } from './MyLogger';

@Injectable({
  providedIn: 'root'
})
export class CJHubService {
  public myLogger: MyLogger = new MyLogger();
  private hubConnection: signalR.HubConnection;
  private cjHubPath: string = JSON.parse(environment.CJHUB);
  public hubConnectionId = '';
  public hasStarted = false;
  public hasInitializedServerEvents = false;
  public connectionDetails: any;
  messageReceived = new EventEmitter<Message>();
  sendReceived = new EventEmitter<Message>();
  connectionEstablished = new EventEmitter<Boolean>();

  public cjHubDebugToConsole = false;

  constructor(private authService: AuthService, private authHttp: HttpClient) {
    this.startConnection();
    this.registerOnServerEvents();
    this.authService.getUserLoginObservable().subscribe(show => {
      this.stopConnection();
    });
    if (localStorage.getItem('cjHubDebugToConsole') != null) {
      this.cjHubDebugToConsole = JSON.parse(localStorage.getItem('cjHubDebugToConsole'));
    }
  }

  public startConnection = () => {
    if (!this.hasStarted) {
      this.hasStarted = true;
      const self = this;
      this.hubConnection = new HubConnectionBuilder()
        .withUrl(this.cjHubPath + 'cjHub?site=www.shuttlebuss.se', {
          accessTokenFactory: () => this.authService.getToken() || ''
        })
        .configureLogging(this.myLogger)
        .build();
      this.hubConnection
        .start()
        .then(() => {
          if (this.cjHubDebugToConsole) {
            console.log('CJHub: Connection established');
          }
          this.connectionEstablished.emit(true);
          this.handleFailures(self);
          self.registerOnServerEvents();
        })
        .catch(err => {
          self.hasStarted = false;
          self.hasInitializedServerEvents = false;
          // console.error('CJHub: Error while establishing connection, retrying...', err);
          if (this.cjHubDebugToConsole) {
            console.error('CJHub: Error while establishing connection, retrying...');
          }
          setTimeout(function() {
            // if (self.authService.loggedIn()) {
            self.startConnection();
            // }
          }, 5000);
        });
    }
  };

  public stopConnection = () => {
    this.hasInitializedServerEvents = false;
    this.hubConnection.stop();
    this.connectionDetails = null;
  };

  public handleFailures(self) {
    self.hubConnection.onclose(function() {
      self.hasStarted = false;
      self.startConnection();
    });
  }

  public getConnectionState(): string {
    if (this.hubConnection) {
      return HubConnectionState[this.hubConnection.state];
    } else {
      return 'Unitialized';
    }
  }

  sendMessage(message: Message) {
    this.hubConnection.invoke('NewMessage', message).catch(err => console.error(err));
  }

  public registerOnServerEvents(): void {
    if (!this.hasInitializedServerEvents) {
      this.hubConnection.on('ConnectionDetails', (data: any) => {
        if (this.cjHubDebugToConsole) {
          console.log('CJHub-ConnectionDetails:', data);
        }
        this.connectionDetails = data;
        this.messageReceived.emit(data);
      });

      this.hubConnection.on('MessageReceived', (data: any) => {
        console.log('CJHub MessageReceived cjHubDebugToConsole:', this.cjHubDebugToConsole);
        if (this.cjHubDebugToConsole) {
          console.log('CJHub-MessageReceived:', data);
        }
        this.messageReceived.emit(data);
      });

      this.hubConnection.on('Send', (data: any) => {
        console.log('CJHub- Send cjHubDebugToConsole:', this.cjHubDebugToConsole);
        if (this.cjHubDebugToConsole) {
          console.log('CJHub-Send:', data);
        }
        this.sendReceived.emit(data);
      });
      this.hasInitializedServerEvents = true;
    }
  }

  public showConsoleDebug() {
    this.cjHubDebugToConsole = true;
    localStorage.setItem('cjHubDebugToConsole', JSON.stringify(this.cjHubDebugToConsole));
  }
  public hideConsoleDebug() {
    this.cjHubDebugToConsole = false;
    localStorage.setItem('cjHubDebugToConsole', JSON.stringify(this.cjHubDebugToConsole));
  }
}
